const integer = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

export function formatUsd(value: number, decimals: 0 | 2 = 0): string {
  return `$${value.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`
}

export function formatInteger(value: number): string {
  return integer.format(value)
}

export function formatPercent(value: number): string {
  return `${(value * 100).toFixed(1)}%`
}

export function formatMultiple(value: number): string {
  return `${value.toFixed(1)}×`
}

export function formatDelta(value: number): string {
  const sign = value > 0 ? '+' : ''
  return `${sign}${formatPercent(value)}`
}
